<template>
  <div>
    <BaseTitle :title="$t('content.view_anal_student')" />
    <v-card class="pa-8 d-flex justify-space-between">
      <div>
        <div class="app-section-title mb-5">
          {{ form.templateName }}
          <br />
        </div>
        <span class="mt-6">
          {{ $t('table.school_name') }} :
          <strong class="ml-2" style="color: #6d6d6d;"> {{ form.schoolName }}</strong>
        </span>
        <span class="ml-6 mr-6"> | </span>
        <span class="mt-6">
          {{ $t('roles.teacher') }} :
          <strong class="ml-2" style="color: #6d6d6d;"> {{ form.teachers.length ? form.teachers.toString() : '-' }}</strong>
        </span>
      </div>
      <v-btn
        color="primary"
        class="btn-primary-custom mt-5 mb-md-0 mr-md-2"
        v-if="listStudent.length && form.editable"
        :loading="loadingPublish"
        @click="publishExport"
      >
        {{ !published ? $t('content.publish_erapor') : $t('content.unpublish_erapor') }}
      </v-btn>
      <v-btn color="primary" v-if="!listStudent.length && form.editable" @click="synSchool" class="btn-primary-custom mt-5 mb-md-0 mr-md-2">{{
        $t('content.generate')
      }}</v-btn>
    </v-card>
    <v-card>
      <div>
        <div class="ml-5 mt-8 mr-5">
          <div class="d-flex align-center justify-space-between">
            <div>
              <v-text-field v-model="search" :label="$t('search')" clearable @change="getData">
                <template #prepend-inner>
                  <svg-icon icon="ic-search" class="primary--text mr-3" />
                </template>
              </v-text-field>
            </div>
            <div class="app-section-title " style="color:#00bf63;">{{ totalStudentTitle }}</div>
          </div>
        </div>
        <template v-if="listStudent.length">
          <div v-for="(item, index) in listStudent" :key="index" class="border-item">
            <v-row class="border-item">
              <v-col md="1" align="center">
                <div class="mt-5 ml-5">
                  <svg-icon icon="ic_erapor" width="35" height="35" class="primary--text" />
                  <v-divider vertical></v-divider>
                </div>
              </v-col>
              <v-col md="10" class="mt-3">
                <div class="d-block">
                  <h3 class="d-inline">
                    <span class="header-content">{{ item.fullName }} </span>
                  </h3>
                </div>
                <div class="d-block">
                  <div>
                    <span class="body-content">
                      <span class="mr-3">
                        NIS :
                        <strong>{{ item.identityNumber ? item.identityNumber : '-' }}</strong>
                      </span>
                      |
                      <span class="mr-3">
                        {{ $t('table.gender') }} :
                        <strong>{{ getGenderLabel(item.gender) }}</strong>
                      </span>
                    </span>
                  </div>
                </div>
                <div class="d-flex"></div>
              </v-col>
              <v-col md="1">
                <template>
                  <div class="pa-5">
                    <v-menu offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <span dark v-bind="attrs" v-on="on">
                          <svg-icon icon="ic-moreaction-black" class="mt-1" />
                        </span>
                      </template>
                      <v-list>
                        <v-list-item>
                          <v-list-item-title class="text-dropdown" @click="viewItem(item.studentId)">{{ $t('view') }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                </template>
              </v-col>
            </v-row>
          </div>
        </template>
        <NoData class="mt-16" v-if="!listStudent.length" />
      </div>
    </v-card>
    <div class="d-flex justify-end align-center mt-5">
      <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="back">{{ $t('back') }}</v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';
import NoData from '@/components/table/NoData';

export default {
  name: 'ViewStudentGenerator',
  components: {
    BaseTitle,
    NoData
  },
  props: {
    isClass: {
      type: Boolean,
      default: false
    },
    isStudent: {
      type: Boolean,
      default: false
    },
    isType: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters({
      classLevel: 'QuizTeacher/classLevel',
      user: 'Auth/user',
      nameCourse: 'CourseList/nameCourse'
    }),
    totalStudentTitle() {
      const totalStudent = this.listStudent?.length ? this.listStudent.length : 0;
      return `${totalStudent} ${this.$t('content.student')}`;
    }
  },
  data: () => ({
    dataClass: '',
    listStudent: [],
    loadingLoad: false,
    titleData: '',
    search: '',
    form: {
      analyticalStudentId: '',
      templateName: '',
      date: '',
      teachers: '',
      schoolName: ''
    }
  }),
  methods: {
    getDataDetail() {
      this.$store.dispatch('Analytical/getListResultStudentDetailByID', this.$route.params.idResult).then(ras => {
        Object.keys(this.form).forEach(form => {
          this.form[form] = ras[form];
        });
      });
    },
    getData() {
      this.loadingLoad = true;
      this.$store
        .dispatch('Analytical/getListResultListStudentDetailByID', { id: this.$route.params.idResult, search: this.search })
        .then(res => {
          this.listStudent = res;
        })
        .finally(() => (this.loadingLoad = false));
    },
    viewItem(studentId) {
      this.$router.push({ name: 'detailResultStudent', params: { idStudent: studentId } });
    },
    getGenderLabel(gender) {
      return gender ? this.$t('form.' + gender.toLowerCase()) : '-';
    },
    back() {
      this.$router.push({ name: 'AnalyticStudentListID', params: { idSidebar: 5 } });
    }
  },
  created() {
    this.getData();
    this.getDataDetail();
  }
};
</script>

<style lang="scss" scoped>
.section-header {
  border-radius: 4px 4px 0 0;

  &.active {
    background: #00bf63;
    .student-title {
      color: #fff;
      font-size: 18px;
      font-weight: bold;
    }
  }

  &.disabled {
    background: #acacac;
    pointer-events: none;

    .student-title {
      color: #fff;
    }
  }
}
.body-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}
.header-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 14px;
  line-height: 16px;
  width: 133px;
  text-align: left;
}
.text-dropdown {
  cursor: pointer;
  &-delete {
    color: red;
    cursor: pointer;
  }
}
</style>
